export { LandingPage } from './component'
